import { render, staticRenderFns } from "./LayoutDistribution.vue?vue&type=template&id=6f9b64ff&scoped=true&"
import script from "./LayoutDistribution.vue?vue&type=script&lang=js&"
export * from "./LayoutDistribution.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDistribution.vue?vue&type=style&index=0&id=6f9b64ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b64ff",
  null
  
)

export default component.exports